import { queryOptions, useQueryClient } from '@tanstack/react-query';
import React, { FC, useEffect, useRef, useState } from 'react';
import { addComma, dateFormat } from 'src/utils/common';
import InputBox from 'src/components/atoms/input/DefInputBox';
import LabelSelect from 'src/components/atoms/selectbox/LabelSelect';
import InputDateBox from 'src/components/atoms/input/InputDateBox';
import CheckBox from 'src/components/atoms/CheckBox';
import './style.scss';

interface Props {
  state: any;
  setState: any;
  viewStatus?: string; // insert, update
}

const InsertForm: FC<Props> = ({ state, setState, viewStatus }) => {
  // const [payloadState, setPayloadState] = useState({ payload });

  // Confirm Input
  const inpResChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, id: string) => {
    const fieldItem: any = state.payload.find((item: any) => item.id === id) || {};

    if (fieldItem.customEvt) {
      fieldItem.customEvt(fieldItem, e.target.value);
    } else {
      fieldItem.value = e.target.value;
      setState({ payload: [...state.payload] });
    }
  };

  const inpChangeNumberEvt = (e: React.ChangeEvent<HTMLInputElement>, id: string) => {
    const fieldItem: any = state.payload.find((item: any) => item.id === id) || {};
    const value: any = e.target?.value.replace(/[^0-9]/g, ''); // 숫자만 허용
    fieldItem.value = Number(value);
    setState({ payload: [...state.payload] });
  };

  // Confirm Checkbox
  const checkClickEvt = (e: any, status: string, field?: string, fieldIdx?: number) => {
    const fieldItem = state.payload.find((item: any) => item.id === field);
    const fieldOption = fieldItem.select.options || [];

    const fIdx = fieldIdx || 0;
    fieldItem.select.checked = fieldOption[fIdx];
    fieldItem.value = fieldItem.select.checked.id;

    if (fieldItem.customEvt) {
      fieldItem.customEvt(fieldItem);
    } else {
      setState({ payload: [...state.payload] });
    }
  };

  // Confirm Date
  const clickCalendarEvt = (date: string, field: string) => {
    const dateStr = date.replaceAll('.', '');
    const fieldItem = state.payload.find((item: any) => item.id === field);
    fieldItem.value = dateStr;
    setState({ payload: [...state.payload] });
  };

  // Confirm Selectbox
  const confirmSelectEvt = (item: any, field: string) => {
    const fieldItem = state.payload.find((item: any) => item.id === field);
    fieldItem.select.checked = item;
    fieldItem.text = item.value;
    fieldItem.value = item.id;

    if (fieldItem.customEvt) {
      fieldItem.customEvt(fieldItem);
    } else {
      setState({ payload: [...state.payload] });
    }
  };

  const inputType = (item: any) => {
    return (
      <InputBox
        placeholder="내용을 입력해주세요."
        boxStyleDef={{ width: '300px' }}
        value={item.value}
        changeEvt={e => inpResChangeEvt(e, item.id)}
      />
    );
  };

  const inputDisableType = (item: any) => {
    let value = item.value;
    if (item.text) value = item.text;
    return <div className="_disable">{value}</div>;
  };
  const inputDefType = (item: any) => {
    const addHtml = item.addHtml;
    let itemValue = item.value;
    if (item.text) itemValue = item.text;
    if (item.type === 'number') itemValue = addComma(Number(itemValue));

    return (
      <div className="_text_div">
        <div className="_text">{itemValue}</div>
        {addHtml ? <div className="_custom">{addHtml}</div> : ''}
      </div>
    );
  };

  const inputNumberType = (item: any) => {
    return (
      <InputBox
        placeholder=""
        boxStyleDef={{ width: '300px' }}
        value={addComma(Number(item.value))}
        changeEvt={e => inpChangeNumberEvt(e, item.id)}
      />
    );
  };

  const selectType = (obj: any) => {
    const selectSet = obj.select || [];
    const addHtml = obj.addHtml;
    return (
      <div className="_select_div">
        <div className={addHtml ? '_select _right' : '_select'}>
          <LabelSelect
            label=""
            select={selectSet}
            boxStyleDef={{ width: '300px' }}
            confirmEvent={confirmSelectEvt}
            field={obj.id}
          />
        </div>
        {addHtml ? addHtml : ''}
      </div>
    );
  };
  const checkType = (obj: any) => {
    const options = obj.select?.options || [];
    const checked = obj.select?.checked || {};
    return (
      <div className="_check_div">
        {options.map((item: any, idx: number) => {
          return (
            <div className="_check_item" key={idx}>
              <CheckBox
                label={item.value}
                selected={checked.id === item.id ? 'on' : 'off'}
                btnClickEvt={checkClickEvt}
                labelStyleDef={{ minWidth: '30px' }}
                field={obj.id}
                fieldIdx={idx}
              />
            </div>
          );
        })}
      </div>
    );
  };
  const dateType = (item: any) => {
    const reDate = dateFormat(item.value || '');
    return (
      <InputDateBox
        status=""
        value={reDate}
        direction="left"
        clickCalendarEvt={clickCalendarEvt}
        divId={item.id}
        styleDef={{ width: '180px', height: '26px' }}
      />
    );
  };

  const contentType = (obj: any, viewType: string) => {
    let reHtml = inputDefType(obj);

    if (viewStatus !== 'insert' && viewStatus !== 'update') {
      reHtml = inputDefType(obj);
    } else {
      if (viewType !== 'D') {
        if (obj.type === 'text') reHtml = inputType(obj);
        if (obj.type === 'number') reHtml = inputNumberType(obj);
        if (obj.type === 'select') reHtml = selectType(obj);
        if (obj.type === 'check') reHtml = checkType(obj);
        if (obj.type === 'date') reHtml = dateType(obj);
      } else {
        reHtml = inputDisableType(obj);
      }
    }
    return reHtml;
  };

  const setContent = () => {
    let payloadSet = state.payload.filter((item: any) => item.list !== 'N') || [];
    if (viewStatus === 'insert')
      payloadSet = state.payload.filter((item: any) => item.insert !== 'N') || [];
    if (viewStatus === 'update')
      payloadSet = state.payload.filter((item: any) => item.update !== 'N') || [];

    return (
      <section className="_content_section">
        <div className="_section">
          {payloadSet.map((item: any, index: number) => {
            let viewType = item.list || ''; // Y, N, D
            if (viewStatus === 'insert') viewType = item.insert || '';
            if (viewStatus === 'update') viewType = item.update || '';
            const zIndex = item.zIndex || 1;
            return (
              <div className={`_item _left ${viewStatus}`} key={index} style={{ zIndex: zIndex }}>
                <div className="_label_div">
                  <div className="_label">{item.label}</div>
                  {item.required === 'Y' ? <div className="_required">필수</div> : ''}
                </div>
                <div className="_content">
                  <div className="_inp_value">{contentType(item, viewType)}</div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    );
  };

  return (
    <div className="_form_data_set_box">
      <div className="_content_box">{setContent()}</div>
    </div>
  );
};

export default InsertForm;
